<ion-header *ngIf="type == 'modal'" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="close()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>Ansprechpartner</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content ArrowKeyUseable [arrowKeysOptions]="arrowKeysOptions"  class="ion-padding" (keydown)="keydown($event)" (keyup)="keyup($event)" [class.popover]="type == 'popover'" [class.modal]="type == 'modal'">
  <div class="search" *ngIf="searchMode">
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
    <input #search type="search" class="search-input" placeholder="Suchen..." [(ngModel)]="filterValue" (keyup)="setFilter($event)"/>
  </div>
  <ion-list>
    <div class="button c-bttn" style="margin-bottom: 15px" *ngIf="!searchMode" (click)="select(null)" >Manuell eingeben</div>
    <section *ngIf="!isLoading">
      <ion-item class="item" *ngFor="let ap of contactPersons; let i = index" (click)="select(ap)" (mouseenter)="arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="arrowKeysOptions.mouseMove.next(true)">
        <ion-label>
          <h2>{{ap.salutation}} {{ap.firstName}} {{ap.lastName}}</h2>
          <h3>{{ap.department}}</h3>
        </ion-label>
      </ion-item>
      <div class="no-content" style="margin: 15px 0;" *ngIf="contactPersons.length == 0">
        Kein Ansprechpartner gefunden
      </div>
    </section>

    <div id="loading" *ngIf="isLoading">
      <ion-icon name="fa-spinner" class="spinner"></ion-icon>
    </div>

  </ion-list>
</ion-content>